import { PanelModes, PanelNames } from "panels/constants"
import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    setPanelModeAction,
    restoredFromSuspenseMemoryAction,
    suspendedVisibilityAction,
} from "./actions"
import store from "integrations/redux/store"
import { selectPanelsModeMap, selectSuspenseMemory } from "./selectors"
import { PanelModeMap } from "./types"

export const defaultPanelsToSuspend = [
    PanelNames.Wallboard,
    PanelNames.Top,
    PanelNames.Bottom,
    PanelNames.Controls,
    PanelNames.Perimeter,
    PanelNames.Left,
    PanelNames.Notifications,
]

export const suspendCurrentlyVisiblePanels = (targets: PanelNames[] = defaultPanelsToSuspend) => {
    const state = store.getState()
    const suspenseMemory = selectSuspenseMemory(state)

    if (typeof suspenseMemory === "undefined") {
        store.dispatch(suspendedVisibilityAction(targets))
    }
}

export const usePanelsState = () => {
    const dispatch = useAppDispatch()
    const modeMap = useAppSelector(selectPanelsModeMap)

    const setMode = useCallback(
        (mode: PanelModes, panel: PanelNames) => {
            dispatch(setPanelModeAction({ panel, mode }))
        },
        [dispatch]
    )

    const restoreSuspendedPanels = useCallback(() => {
        dispatch(restoredFromSuspenseMemoryAction())
    }, [dispatch])

    // intended for hiding most panels when snapshot panel is pulled up
    const suspendPanels = useCallback((targets?: PanelNames[]) => {
        suspendCurrentlyVisiblePanels(targets)
    }, [])

    const isLockedPanel = useCallback(
        (name: PanelNames) => {
            return modeMap[name] !== PanelModes.MaximizedLocked
        },
        [modeMap]
    )

    return {
        mode: modeMap as PanelModeMap,
        suspendPanels,
        restoreSuspendedPanels,
        isLockedPanel,
        setMode,
    }
}

export default usePanelsState
